import { AutodeskIntegrationIcon, ProcoreIntegrationIcon } from "@components/common/icons";
/** Information of each integration */
export const INTEGRATION_INFO = {
  autodesk: {
    displayName: "Autodesk",
    description: "Create and view RFIs and Issues directly within the platform.",
    icon: AutodeskIntegrationIcon
  },
  procore: {
    displayName: "Procore",
    description: "Create and view RFIs and Observations directly within the platform.",
    icon: ProcoreIntegrationIcon
  }
};